export default __webpack_public_path__ + "static/logo-6-284d6e8417d5e0699419b54c69721a80.webp";